function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "var(--n-color-border)"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_414_15067)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.4058 18.0332C18.3155 18.0332 18.2252 17.9987 18.1562 17.9298C18.0184 17.7918 18.0184 17.5683 18.1562 17.4305L20.5563 15.0305C21.5447 14.0422 21.5447 12.4342 20.5564 11.4459C19.568 10.4575 17.9599 10.4575 16.9716 11.4459L14.5715 13.8459C14.4336 13.9838 14.21 13.9838 14.0721 13.8459C13.9343 13.708 13.9343 13.4844 14.0721 13.3467L16.4723 10.9465C17.7359 9.68287 19.7919 9.68287 21.0556 10.9465C22.3192 12.2102 22.3192 14.2662 21.0555 15.5297L18.6555 17.9298C18.5867 17.9987 18.4963 18.0332 18.4058 18.0332Z",
  fill: "var(--n-color-text-dark)",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.2409 22.0007C12.3751 22.0007 11.5613 21.6635 10.9491 21.0514C10.337 20.4393 10 19.6255 10 18.7598C10 17.8941 10.3371 17.0804 10.9491 16.4682L12.5233 14.8942C12.6613 14.7563 12.8848 14.7563 13.0226 14.8942C13.1605 15.032 13.1605 15.2555 13.0226 15.3934L11.4485 16.9676C10.9697 17.4462 10.7061 18.0828 10.7061 18.7598C10.7061 19.4369 10.9697 20.0734 11.4484 20.5521C11.9272 21.0309 12.5638 21.2947 13.2409 21.2947C13.9179 21.2947 14.5545 21.0311 15.0332 20.5522L16.6073 18.9781C16.7453 18.8403 16.9688 18.8403 17.1066 18.9781C17.2444 19.1161 17.2444 19.3396 17.1066 19.4774L15.5324 21.0515C14.9204 21.6636 14.1065 22.0007 13.2409 22.0007Z",
  fill: "var(--n-color-text-dark)",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6343 18.7258C13.544 18.7258 13.4536 18.6914 13.3847 18.6224C13.2468 18.4846 13.2468 18.261 13.3847 18.1232L18.1312 13.3766C18.269 13.2387 18.4926 13.2387 18.6305 13.3766C18.7684 13.5145 18.7684 13.7381 18.6305 13.876L13.884 18.6225C13.815 18.6914 13.7247 18.7258 13.6343 18.7258Z",
  fill: "var(--n-color-text-dark)",
  stroke: "var(--n-color-text-dark)",
  strokeWidth: 0.1,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_414_15067"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(8 8)"
})));

function SvgIconCopyLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyLink);
export default __webpack_public_path__ + "static/media/icon-copy-link.ae5d5a2739660804a82449f5698b8001.svg";
export { ForwardRef as ReactComponent };